import { render, staticRenderFns } from "./PuntosDeEntregaListaItemProducto.vue?vue&type=template&id=997cda3c&"
import script from "./PuntosDeEntregaListaItemProducto.vue?vue&type=script&lang=js&"
export * from "./PuntosDeEntregaListaItemProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports